import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "lawn_tasks_v1"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.loadState()
  }

  loadState() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}")
      this.checkboxTargets.forEach((cb) => {
        cb.checked = !!saved[cb.dataset.lawnTaskId]
      })
    } catch (_e) {
      // ignore corrupt data
    }
  }

  toggle(event) {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}")
      const id = event.target.dataset.lawnTaskId
      saved[id] = event.target.checked
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved))
    } catch (_e) {
      // ignore
    }
  }

  resetAll() {
    localStorage.removeItem(STORAGE_KEY)
    this.checkboxTargets.forEach((cb) => {
      cb.checked = false
    })
  }
}
